import { useTranslation } from 'react-i18next';
import PostList from '@/components/feature/PostList';
import { useApiData } from '@/lib/use-api-data';
import { adaptFeedItem } from '@/lib/adapters/post';
import type { PostsEnvelope } from '@/lib/adapters/api-types';
import type { FeedItem } from '@/lib/adapters/types';

export default function DiscussionPreview() {
  const { t } = useTranslation();
  // SSR(server.mjs home)与客户端重取共用同一路径 /api/posts?limit=8(全类型最新 8 条)。
  // 必须同源:SSR 若注入空信封,useApiData 会把它当有效 data 且不再客户端补取。
  const { data, loading } = useApiData<PostsEnvelope>('posts', '/api/posts?limit=8');
  const items: FeedItem[] = data ? data.posts.map(adaptFeedItem) : [];

  // 无帖且非加载:整章隐藏,避免「正在讨论」空壳夹在 Focus 与页脚之间
  if (!loading && items.length === 0) return null;

  return (
    <section className="w-full bg-background-50" aria-label={t('discussion.sublabel')}>
      <div className="max-w-[720px] mx-auto px-4 md:px-6 py-10 md:py-14">
        {/* 刊章 teaser:章节头 + 最新 8 帖 + 查看全部;无 type/sort chrome(筛选在 /feed) */}
        <PostList showHeader showFilters={false} items={items} loading={!data && loading} />
      </div>
    </section>
  );
}
